import React from 'react';

const ProgressBar = (props) => {
    const {
        title               = null,
        currentStepNumber   = 1,
        totalStepNumber     = 5
    } = props;

    const calculateWidth = () => {
        let percentage = Math.round((currentStepNumber / totalStepNumber) * 100);

        return percentage > 100 ? '100%' : percentage+'%';
    }

    const renderTitle = () => {
        if (!title) {
            return null;
        }

        return (
            <div className={"progress-title"}>{title}&nbsp;-&nbsp;</div>
        );
    }

    const renderStep = () => {
        return (
            <div className={"progress-step"}><span>Step</span> {currentStepNumber}/{totalStepNumber}</div>
        );
    }

    return (
        <div className={"progress-bar-container"}>
            <div className={"step-container"}>
                <div className={"alignment"}>
                    {renderTitle()}
                    {renderStep()}
                </div>
            </div>
            <div className={"progress-bar"}>
                <div className={"background"}></div>
                <div className={"position"} style={{width: calculateWidth()}}></div>
            </div>
        </div>
    );
}

export default ProgressBar;
